import PropTypes from "prop-types";
import {UseLoader} from "../../../hooks/useLoader";
import React, {useEffect, useRef, useState} from "react";
import {Toast} from "primereact/toast";
import {Dialog} from "primereact/dialog";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import {
    getdataAsociadoDeduccionModal,
    borrarAsociadoDeduccion,
    updateAsociadoDeduccion
} from "../../../api/asociadoDeduccion.service";
import {useForm} from "react-hook-form";
import {confirmDialog} from "primereact/confirmdialog";

export const ModalEditarAsociadoDeduccion= ({show, hide, asoDedu}) => {
    const [handleLoader] = UseLoader();
    const toast = useRef(null);
    const [terceros, setTerceros] = useState([]);
    const [cuenta, setCuenta] = useState([]);
    const [asociados, setAsociados] = useState([]);
    const {register, handleSubmit, formState: {errors}} = useForm();

    const initParams= {
        tercero: "",
        deduccion: "",
        asociadodedu_id: "",
        asociado_id: ""
    };

    const [field, setField] = useState(initParams);

    const onSubmit= (e) => {
        try {
            e.preventDefault();

            const payload= {
                tercero: field.tercero,
                deduccion: field.deduccion,
                asociadodedu_id: asoDedu.asociadodeduccion_id,
                asociado_id: asoDedu.asociado_id
            }

            if(payload.tercero === '' || payload.deduccion === '' ) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Validar campos",
                    life: 3000
                });
                return;
            }

            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () => {
                    handleLoader(true)
                    payload.tercero = field.tercero;
                    payload.deduccion = field.deduccion;
                    const response = await updateAsociadoDeduccion(payload);
                    const data = await response;
                    handleLoader(false)
                    if (data.estado !== 200) {
                        toast.current?.show({severity: 'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }
                    toast.current?.show({severity: 'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                    hide();
                }
            })


        }  catch (e) {
            handleLoader(false)
            console.log(e)
        }
    }

    useEffect(() => {
        if (show) {
            getSelect().then(r => {
                if (r.estado === 200) {
                    const data = r;
                    setCuenta(data.dataCuenta);
                    setAsociados(data.data);
                    setTerceros(data.dataTerceros);
                } else {
                    toast.current?.show({severity: 'warn', summary: 'Alerta', detail: r.mensaje, life: 3000});
                }
            });
        }
        return () => {
            setTerceros([]);
            setCuenta([]);
            setAsociados([]);
        };
    }, [show]);

    useEffect(() => {
        setField({
            tercero: asoDedu.tercero_id,
            deduccion: asoDedu.cuentadeduccion_id,
            asociado_id: asoDedu.asociado_id
        })

        return () => {
            setField(initParams)
        };
    }, [asoDedu]);

    const deleteDeduccion = async () => {
        try {
            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () =>  {
                    handleLoader(true);
                    const response= await borrarAsociadoDeduccion(asoDedu);
                    const data= await response;
                    handleLoader(false);
                    if (data.estado !== 200) {
                        toast.current?.show({severity:'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }

                    toast.current?.show({severity:'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                    hide();
                }
            });
        } catch (e) {
            handleLoader(false)
            console.log(e)
        }
    }

    const getSelect = async () => {
        try {
            const response = await getdataAsociadoDeduccionModal();
            //console.log(response);
            return await response;
        } catch (e) {
            console.log(e)
        }
    }


    return (
        <div>
            <Toast ref={toast}/>
            <Dialog modal maximizable header="Editar Asociado Deducciones" visible={show} style={{width: '50vw'}}
                    onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form onSubmit={onSubmit} autoComplete="false">
                            <h6 className="title-modal">
                                Información Asociado
                            </h6>
                            <div className="row">
                                <ContainerGroupForm width="lg:w-6/12">
                                    <label
                                        className="label-form"
                                        htmlFor="deduccion"
                                    >
                                        Deduccion
                                    </label>
                                    <select
                                        className="form-input-small"
                                        required
                                        onChange={(e) => setField({...field, deduccion: e.target.value})}
                                        value={field.deduccion}
                                        id="deduccion">
                                        <option value="">Seleccione</option>
                                        {cuenta.map((itm, i) => <option key={i} value={itm.cuentadeduccion_id}>{itm.descripcion}</option>)}
                                    </select>
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-6/12">
                                    <label
                                        className="label-form"
                                        htmlFor="tercero"
                                    >
                                        Tercero
                                    </label>
                                    <select
                                        className="form-input-small"
                                        required
                                        value={field.tercero}
                                        onChange={(e) => setField({...field, tercero: e.target.value})}
                                        id="tercero">
                                        <option value="">Seleccione</option>
                                        {terceros.map((itm, i) => <option key={i} value={itm.tercero_id}>{itm.nombre}</option>)}
                                    </select>
                                </ContainerGroupForm>
                            </div>
                            <hr className="mt-6 border-b-1 border-blueGray-300"/>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-4/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Actualizar
                                    </button>
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <button
                                        className="danger-color-btn btn w-full"
                                        type="button"
                                        onClick={handleSubmit(deleteDeduccion)}
                                    >
                                        Eliminar
                                    </button>

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <button
                                        className="warning-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>

                                </ContainerGroupForm>
                            </div>
                        </form>
                    </ContainerForm>
                </div>

            </Dialog>
        </div>
    )
}


ModalEditarAsociadoDeduccion.propTypes = {
    show: PropTypes.bool,
    hide: PropTypes.func,
    asoDedu: PropTypes.object
};


ModalEditarAsociadoDeduccion.defaultProps = {
    show: false,
};
